import { render, staticRenderFns } from "./edit-project.vue?vue&type=template&id=ae12594c"
import script from "./edit-project.vue?vue&type=script&lang=js"
export * from "./edit-project.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports